
<mat-form-field  *ngIf="cagad_network_object.length>0"> <!--appearance="fill"-->
  <mat-label>Select Network</mat-label>
  <mat-select (selectionChange)="selectNetworkEvent($event)">
    <mat-option *ngFor="let dt of cagad_network_object" [value]="dt.id">
      {{dt.name}}
    </mat-option>
  </mat-select>
</mat-form-field>
